class DownloadsQue {
  #data = null;
  setActive(mesh) {
    this.#data = mesh;
  }
  get data() {
    return this.#data;
  }
}
export const sharedDownloadQueue = new DownloadsQue();